export const CONTACT = {
  address: "Via Prusst snc, 00030 San Cesareo (RM)",
  phone: "+39 06 232514",
  phoneHref: "tel:+3906232514",
  email: "commerciale@security.it",
  fax: "+39 06 23279946",
  altEmail: "securitysrl@security.it",
  careerUrl: "https://inrecruiting.intervieweb.it/securityit/it/career",
  axentraUrl: "https://www.axentrasrl.com",
  astraUrl: "https://www.inquiria.eu",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/servizi", label: "Servizi" },
  { to: "/obiettivi-sensibili", label: "Obiettivi sensibili" },
  { to: "/centrale-operativa", label: "Centrale operativa" },
  { to: "/contatti", label: "Contatti" },
];

/* Voci del sottomenu "Servizi" nel pannello mobile */
export const MENU_SERVICES = [
  ["Pronto intervento", "/servizi/pronto-intervento"],
  ["Antirapina", "/servizi/antirapina"],
  ["Pattugliamento", "/servizi/pattugliamento"],
  ["Antitaccheggio", "/servizi/antitaccheggio"],
  ["Piantonamento", "/servizi/piantonamento"],
  ["Custodia valori", "/servizi/custodia-valori"],
  ["Trasporto valori", "/servizi/trasporto-valori"],
  ["Sala conta", "/servizi/sala-conta"],
  ["Scorta valori", "/servizi/scorta-valori"],
  ["Unità cinofila", "/servizi/cinofili"],
  ["Portierato", "/servizi/portierato"],
  ["Controllo accessi", "/servizi/portierato"],
  ["Control room", "/centrale-operativa"],
  ["Eventi", "/servizi/eventi"],
];

export const STATS = [
  { to: 1992, label: "anno di fondazione del marchio", plain: "1992" },
  { to: 2, label: "centrali operative certificate", plain: null },
  { to: 6, label: "aeroporti presidiati", plain: null },
  { to: null, label: "assistenza e pronto intervento", plain: "24/7" },
];

export const CLIENTS_ROW1 = [
  ["aeroporti-di-roma", "Aeroporti di Roma"],
  ["air-algerie", "Air Algérie"],
  ["air-china", "Air China"],
  ["air-ocean-cargo", "Air Ocean Cargo"],
  ["air-transat", "Air Transat"],
  ["alha-group", "Alha Group"],
  ["asl-frosinone", "ASL Frosinone"],
  ["atac-roma", "ATAC Roma"],
  ["aviapartner", "Aviapartner"],
  ["bekaert", "Bekaert"],
  ["cotral", "Cotral"],
  ["croce-bianca-italiana", "Croce Bianca Italiana"],
  ["eni", "Eni"],
  ["federazione-italiana-canoa-kayak", "Federazione Italiana Canoa Kayak"],
  ["federazione-italiana-sport-equestri", "Federazione Italiana Sport Equestri"],
  ["finso", "Finso"],
  ["gategourmet", "Gategourmet"],
];

export const CLIENTS_ROW2 = [
  ["korean-air", "Korean Air"],
  ["mle-aircargo", "MLE Aircargo"],
  ["ospedale-israelitico", "Ospedale Israelitico"],
  ["provincia-di-rieti", "Provincia di Rieti"],
  ["roma-capitale", "Roma Capitale"],
  ["saudia", "Saudia"],
  ["sda", "SDA"],
  ["strada-dei-parchi", "Strada dei Parchi"],
  ["terna", "Terna"],
  ["tunisair", "Tunisair"],
  ["wartsila", "Wärtsilä"],
  ["xph", "XPH"],
  ["xpo-logistics", "XPO Logistics"],
  ["zetema", "Zètema"],
];

export const CERTS = [
  ["uni-10891", "UNI 10891", "Istituti di vigilanza privata"],
  ["uni-cei-en-50518", "UNI CEI EN 50518", "Centrali operative, due sedi"],
  ["uni-10459", "UNI 10459", "Professionisti della security"],
  ["iso-9001", "ISO 9001", "Gestione della qualità"],
  ["iso-14001", "ISO 14001", "Gestione ambientale"],
  ["iso-45001", "ISO 45001", "Salute e sicurezza sul lavoro"],
  ["iso-50001", "ISO 50001", "Gestione dell'energia"],
  ["iso-iec-27001", "ISO/IEC 27001", "Sicurezza delle informazioni"],
  ["sa-8000", "SA 8000", "Responsabilità sociale"],
  ["uni-pdr-125", "UNI/PdR 125", "Parità di genere"],
  ["ecovadis", "EcoVadis", "Rating di sostenibilità"],
  ["nato-ncage", "NATO NCAGE", "Codice fornitore AT086"],
];

export const AIRPORTS = [
  ["FCO", "Roma Fiumicino"],
  ["CIA", "Roma Ciampino"],
  ["MXP", "Milano Malpensa"],
  ["LIN", "Milano Linate"],
  ["BGY", "Bergamo Orio al Serio"],
  ["TRN", "Torino Caselle"],
];

const A = "/assets";

export const SERVICES = {
  armata: [
    {
      id: "pronto-intervento",
      name: "Pronto intervento su allarme",
      img: `${A}/foto/pattuglia-auto.jpg`,
      desc: "Il tuo allarme collegato alle centrali H24: quando scatta, una guardia giurata armata arriva sul posto, verifica e ti invia l'esito.",
      ideale: "Case, uffici, negozi e magazzini con impianto di allarme.",
      inc: [
        "Collegamento alla centrale 7 giorni su 7",
        "Pattuglie armate geolocalizzate",
        "Ispezione di perimetro e accessi",
        "Rapporto di intervento scritto",
      ],
    },
    {
      id: "pattugliamento",
      name: "Pattugliamento e vigilanza ispettiva",
      img: `${A}/foto/flotta-pattuglie.jpg`,
      desc: "Ronde programmate e a sorpresa con mezzi contrassegnati: la dissuasione giusta quando il piantonamento costante non serve.",
      ideale: "Cantieri, aree comunali, zone industriali e condomìni.",
      inc: [
        "Percorsi e orari concordati",
        "Rapporto di ronda con esito",
        "Controllo di chiusure e accessi",
        "Cartelli di dissuasione",
      ],
    },
    {
      id: "piantonamento",
      name: "Piantonamento e vigilanza fissa",
      img: `${A}/foto/guardia-aeroporto-cargo.jpg`,
      desc: "Presidio armato e costante di aziende, cantieri, ospedali ed eventi, preceduto da un'analisi del rischio per ogni postazione.",
      ideale: "Aziende, ospedali, cantieri e grandi eventi.",
      inc: [
        "Analisi del rischio iniziale",
        "Guardie giurate armate",
        "Sostituzioni garantite",
        "Referente dedicato",
      ],
    },
    {
      id: "antirapina",
      name: "Vigilanza antirapina",
      img: `${A}/foto/guardia-presidio-orizzontale.jpg`,
      desc: "Guardie in divisa per banche, gioiellerie e negozi di valore: presenza visibile e procedure di apertura e chiusura sicure.",
      ideale: "Banche, gioiellerie, farmacie e cartolerie di valore.",
      inc: [
        "Presidio in divisa all'ingresso",
        "Scorta all'apertura e alla chiusura",
        "Procedure antirapina",
        "Collegamento costante alla centrale",
      ],
    },
    {
      id: "trasporto-valori",
      name: "Trasporto valori",
      img: `${A}/foto/furgoni-blindati.jpg`,
      desc: "Mezzi blindati geolocalizzati e personale armato per il trasporto di contanti e valori, con sorveglianza in tempo reale.",
      ideale: "Banche, retail e gestori di ATM.",
      inc: [
        "Furgoni blindati e tracciati",
        "Equipaggio armato dedicato",
        "Percorsi variabili",
        "Assicurazione del carico",
      ],
    },
    {
      id: "custodia-valori",
      name: "Custodia valori",
      img: `${A}/foto/magazzino-custodia.jpg`,
      desc: "Sala conta, caveau e cassette di sicurezza in strutture di proprietà, sorvegliate 24 ore su 24.",
      ideale: "Gestori di ATM, aziende con giacenze di valori.",
      inc: [
        "Caveau di proprietà",
        "Cassette di sicurezza",
        "Videocontrollo H24",
        "Tracciabilità di ogni movimentazione",
      ],
    },
    {
      id: "sala-conta",
      name: "Sala conta",
      img: `${A}/foto/caveau.jpg`,
      desc: "Conteggio, controllo e confezionamento di contante e monete in sale dedicate e videosorvegliate, con procedure a doppio controllo e tracciabilità di ogni operazione.",
      ideale: "Grande distribuzione, catene di negozi, aziende con incassi giornalieri, gestori di ATM.",
      inc: [
        "Conteggio e controllo delle banconote",
        "Doppio controllo e videoregistrazione",
        "Versamento o riconsegna secondo le istruzioni del cliente",
        "Rendiconto di ogni operazione",
      ],
      col: ["trasporto-valori", "custodia-valori"],
    },
    {
      id: "scorta-valori",
      name: "Scorta valori",
      img: `${A}/foto/trasporto-valori-guardia.jpg`,
      desc: "Scorta armata di beni e valori in movimento: carichi di pregio, convogli e trasferimenti sensibili, affidati a guardie particolari giurate in collegamento costante con la centrale operativa.",
      ideale: "Aziende con merci di pregio, logistica, gioiellerie e case di moda, eventi.",
      inc: [
        "Pianificazione del percorso",
        "Scorta con auto e guardie armate",
        "Geolocalizzazione e contatto H24 con la centrale",
        "Rapporto di servizio",
      ],
      col: ["trasporto-valori", "sala-conta"],
    },
    {
      id: "antitaccheggio",
      name: "Vigilanza antitaccheggio",
      img: `${A}/ill/ill-antitaccheggio.svg`,
      desc: "Addetti in borghese dentro negozi e grande distribuzione: individuano i taccheggiatori e agiscono prima del danno.",
      ideale: "Grande distribuzione, retail, fiere e outlet.",
      inc: [
        "Addetti in borghese selezionati",
        "Intervento senza bloccare la clientela",
        "Sorveglianza dei reparti critici",
        "Rapporti periodici al gestore",
      ],
    },
    {
      id: "cinofili",
      name: "Unità cinofile",
      img: `${A}/ill/ill-cinofila.svg`,
      desc: "Binomi conduttore-cane per ricerca esplosivi, bonifica di eventi e sedi, vigilanza e deterrenza.",
      ideale: "Eventi, aeroporti e aree critiche.",
      inc: [
        "Ricerca esplosivi e bonifiche",
        "Deterrenza visibile",
        "Conduttori certificati",
        "Servizi programmati o a chiamata",
      ],
    },
  ],
  nonarmata: [
    {
      id: "portierato",
      name: "Controllo accessi e guardiania",
      img: `${A}/foto/control-room.jpg`,
      desc: "Personale fiduciario per reception, varchi, cancellerie e cantieri: accoglie, filtra e registra chi entra ed esce.",
      ideale: "Sedi aziendali, condomìni, enti pubblici.",
      inc: [
        "Filtraggio degli accessi",
        "Registro entrate e uscite",
        "Gestione visitatori",
        "Servizio anche in lingua straniera",
      ],
    },
    {
      id: "eventi",
      name: "Accoglienza per eventi e fiere",
      img: `${A}/ill/ill-eventi.svg`,
      desc: "Steward e addetti all'accoglienza per concerti, fiere, congressi e manifestazioni sportive, anche multilingue.",
      ideale: "Eventi, fiere, stadi, musei e congressi.",
      inc: [
        "Steward e accoglienza ospiti",
        "Controllo biglietteria e inviti",
        "Gestione dei flussi",
        "Postazione informazioni",
      ],
    },
    {
      id: "aeroportuale",
      name: "Sicurezza aeroportuale",
      img: `${A}/foto/controllo-esplosivi.jpg`,
      desc: "Controllo passeggeri, bagagli e merci negli scali, con personale certificato ENAC e Polizia di Stato.",
      ideale: "Aeroporti, cargo e handler.",
      inc: [
        "Addetti certificati ENAC",
        "Controllo merci e posta",
        "Presidi varchi airside",
        "Incaricati di pubblico servizio",
      ],
    },
    {
      id: "porti-stazioni",
      name: "Porti, stazioni e trasporti",
      img: `${A}/foto/sicurezza-ferroviaria.jpg`,
      desc: "Sicurezza sussidiaria in stazioni, porti e mezzi di trasporto, secondo il D.M. 154/2009.",
      ideale: "Porti, stazioni, metropolitane e autolinee.",
      inc: [
        "Addetti di sicurezza sussidiaria",
        "Presidi di banchina e binario",
        "Collaborazione con le Forze dell'Ordine",
        "Rapporti alle autorità",
      ],
    },
  ],
};

export const HOME_SERVICES = [
  ["Pronto intervento su allarme", "Il tuo allarme collegato alla centrale H24: quando scatta, una guardia giurata armata arriva sul posto, verifica e ti invia l'esito.", "/centrale-operativa"],
  ["Piantonamento e vigilanza fissa", "Presidio armato e costante di aziende, cantieri, ospedali ed eventi, preceduto da un'analisi del rischio per ogni postazione.", "/servizi"],
  ["Trasporto e custodia valori", "Mezzi blindati geolocalizzati, sala conta, caveau e cassette di sicurezza protetti 24 ore su 24.", "/servizi"],
  ["Antirapina e antitaccheggio", "Guardie in divisa e in borghese per negozi, gioiellerie, farmacie e grande distribuzione.", "/servizi"],
  ["Controllo accessi e guardiania", "Personale fiduciario e guardiania per reception, varchi, magazzini e cantieri, anche in lingua straniera.", "/servizi"],
  ["Unità cinofile", "Binomi conduttore-cane per ricerca esplosivi, bonifica di eventi e sedi, vigilanza e deterrenza.", "/servizi"],
];

export const PI_STEPS = [
  ["L'allarme scatta", "Il tuo impianto avvisa la centrale operativa: il segnale arriva comunque, anche se la sirena viene silenziata."],
  ["La centrale prende in carico", "Un operatore verifica la segnalazione e chiama subito la pattuglia più vicina, grazie alla geolocalizzazione dei mezzi."],
  ["La guardia giurata interviene", "Arriva sul posto, ispeziona perimetro e accessi e, se ci hai consegnato le chiavi, verifica l'interno secondo le procedure concordate."],
  ["Ricevi l'esito", "Un rapporto con orari, controlli eseguiti e azioni intraprese. Se serve, allertiamo subito le Forze dell'Ordine."],
];

export const PI_INCLUDES = [
  ["Collegamento H24", "Alla centrale operativa 7 giorni su 7, festivi compresi."],
  ["Presa in carico immediata", "Ogni segnalazione viene gestita subito da un operatore."],
  ["App di monitoraggio", "Stato dell'impianto ed esiti degli interventi sul telefono."],
  ["Rapporto di intervento", "Orari, controlli eseguiti e azioni intraprese."],
  ["Doppia centrale", "Se una sala operativa non è disponibile, l'altra subentra senza interruzioni."],
  ["Sopralluogo gratuito", "Verifichiamo il tuo impianto prima di collegarlo."],
];

export const AREAS = [
  {
    label: "Aeroporti",
    norm: "D.M. 269/2010",
    title: "Sicurezza aeroportuale",
    img: `${A}/foto/aeroporto-tramonto-orizzontale.jpg`,
    text: "Varchi, passeggeri, bagagli e merci negli scali principali, con addetti certificati ENAC e Polizia di Stato e presidio delle aree airside.",
    inc: ["Controllo merci e posta", "Presidio varchi e airside", "Incaricati di pubblico servizio", "Contratti con aziende partner"],
  },
  {
    label: "Porti",
    norm: "D.M. 154/2009",
    title: "Sicurezza portuale",
    img: `${A}/ill/ill-porti.svg`,
    text: "Sicurezza sussidiaria negli approcci marittimi: banchine, varchi, terminal e merci, in coordinamento con le autorità portuali.",
    inc: ["Presidi di banchina e terminal", "Controllo varchi e recinti", "Servizi su navi e stazioni marittime", "Rapporti alle Autorità"],
  },
  {
    label: "Stazioni e ferrovie",
    norm: "D.M. 154/2009",
    title: "Sicurezza ferroviaria",
    img: `${A}/foto/sicurezza-ferroviaria.jpg`,
    text: "Servizi di sicurezza sussidiaria in stazioni, depositi, metropolitane e mezzi di trasporto pubblico, su tutto il territorio.",
    inc: ["Presidi in stazione e sui mezzi", "Controllo accessi e biglietteria", "Sorveglianza di depositi e cantieri", "Collaborazione con le Forze dell'Ordine"],
  },
];

export const VISITS = {
  title: "Visite di Stato e delegazioni internazionali",
  text: "Abbiamo preso parte al presidio di aeromobili e aree aeroportuali in occasione di visite di Stato e delegazioni internazionali, tra cui quelle di Stati Uniti e Cina, operando secondo protocolli rigorosi e in coordinamento con le autorità competenti.",
  cards: [
    ["Stati Uniti", "Presidio di aeromobili di Stato"],
    ["Cina", "Visita di Stato"],
    ["Delegazioni internazionali", "Presidio delle aree aeroportuali"],
  ],
};

export const OBIETTIVI_BENTO = [
  ["Trasporti", "Aeroporti, porti, stazioni, metropolitane, centri di smistamento."],
  ["Grandi eventi e cultura", "Stadi, fiere, concerti, congressi, musei e mostre."],
  ["Energia e infrastrutture", "Aziende energetiche e idriche, raffinerie, depositi carburanti."],
  ["Telecomunicazioni e dati", "Operatori di rete, emittenti nazionali, data center."],
  ["Istituzioni", "Ambasciate, edifici pubblici, enti previdenziali, ospedali."],
  ["Valori e industria", "Banche, siti con giacenza di valori, stabilimenti industriali."],
];

export const STRUTTURE_STATS = [
  ["2", "centrali operative certificate"],
  ["24/7", "centrali in backup reciproco"],
  ["1", "centro di controllo valori"],
  ["3", "caveau"],
  ["2", "sale conta"],
  ["6.000", "metri quadrati di proprietà"],
];

export const SEDI = [
  ["Sede generale e centrale operativa", "San Cesareo (RM)", "Via Prusst snc, 00030 · Tel. +39 06 232514"],
  ["Centrale operativa Nord", "Bascapè (PV)", "Via Crivelli 9, 27010"],
  ["Base logistica aeroportuale", "Fiumicino (RM)", "Aeroporto Leonardo da Vinci · Tel. +39 06 65954695"],
  ["Base logistica aeroportuale", "Malpensa (VA)", "Aeroporto di Milano Malpensa"],
  ["Base logistica", "Orbassano (TO)", "Via Primo Maggio 2/5"],
  ["Base logistica", "Firenze", ""],
  ["Sede operativa", "Collecchio (PR)", "Corso Eguaglianza 4, 43044"],
  ["Sede operativa", "Bolzano", "Via del Macello 50, 39100"],
  ["Sede operativa", "Bari", "Viale Giuseppe Degennaro 1, 70123"],
];

export const DOCS = [
  "Codice etico",
  "Politica aziendale integrata",
  "Responsabilità sociale (SA 8000)",
  "Diversità e inclusione",
  "Politica per la sicurezza informatica",
  "Gestione del lavoro infantile e minorile",
];

export const FAQS = {
  home: [
    ["Che cos'è un istituto di vigilanza privata autorizzato?", "È un'azienda autorizzata dal Prefetto, ai sensi dell'art. 134 del TULPS, a svolgere servizi di vigilanza e custodia con guardie particolari giurate. Orion Security opera con licenza prefettizia n. 283167 ed è certificata UNI 10891."],
    ["Che differenza c'è tra vigilanza armata e non armata?", "La vigilanza armata è svolta da guardie particolari giurate e protegge beni, valori e persone. La vigilanza non armata comprende servizi fiduciari come portierato, reception e controllo accessi. Orion Security offre entrambe."],
    ["Quanto costa la vigilanza con pronto intervento?", "Dipende da immobile, zona e servizi scelti. Sopralluogo e preventivo sono gratuiti e si possono richiedere dal sito, al telefono o in chat con l'assistente AI, a qualsiasi ora."],
    ["La centrale operativa è attiva di notte e nei festivi?", "Sì. Le centrali di San Cesareo (Roma) e Bascapè (Pavia) sono attive 24 ore su 24, 365 giorni l'anno, e certificate UNI CEI EN 50518."],
    ["In quali zone operate?", "Sede generale a San Cesareo (Roma), centrale a Bascapè (Pavia), basi a Fiumicino, Malpensa, Torino, Firenze, Parma, Bolzano e Bari, e sei aeroporti. I servizi non armati sono attivi in tutta Italia."],
  ],
  servizi: [
    ["Cosa fa una guardia particolare giurata?", "È un operatore autorizzato con decreto del Prefetto a proteggere beni mobili e immobili. Presidia, ispeziona, interviene su allarme e trasporta valori, in contatto con la centrale operativa e le Forze dell'Ordine."],
    ["Posso attivare un servizio solo per un evento o per pochi giorni?", "Sì. Piantonamento, servizi fiduciari, steward e unità cinofile sono disponibili anche per periodi brevi, eventi, fiere e cantieri temporanei."],
    ["Il personale non armato parla altre lingue?", "Sì, forniamo addetti all'accoglienza e al portierato che parlano inglese e altre lingue, per hotel, sedi internazionali, ambasciate ed eventi."],
    ["Gestite anche l'impianto di allarme?", "Progettazione e installazione sono curate da Axentra Srl, azienda del nostro gruppo. Noi colleghiamo l'impianto alla centrale e garantiamo il pronto intervento."],
  ],
  centrale: [
    ["Cosa succede se i ladri disattivano la sirena?", "Il segnale arriva comunque alla centrale tramite il comunicatore dell'impianto. La sirena può essere silenziata, la segnalazione no."],
    ["In quanto tempo arriva la guardia?", "Dipende dalla zona e dal traffico. La centrale individua sempre la pattuglia più vicina grazie alla geolocalizzazione dei mezzi."],
    ["La guardia può entrare in casa?", "Ispeziona perimetro e accessi. Se ci consegni le chiavi, può verificare anche l'interno secondo le procedure concordate. In caso di effrazione la centrale allerta subito le Forze dell'Ordine."],
    ["Posso collegare il mio impianto attuale?", "Nella maggior parte dei casi sì. Al sopralluogo gratuito verifichiamo la compatibilità; se serve, Axentra aggiorna l'impianto."],
  ],
  obiettivi: [
    ["Cosa si intende per obiettivo sensibile?", "Un sito di interesse pubblico o strategico che richiede misure di sicurezza superiori alla norma. Il D.M. 269/2010 stabilisce che, quando non provvedono le Forze dell'Ordine, la sua sicurezza è affidata esclusivamente a guardie particolari giurate."],
    ["In quali aeroporti opera Orion Security?", "Tramite accordi con aziende partner operiamo negli aeroporti di Roma Fiumicino, Roma Ciampino, Milano Malpensa, Milano Linate, Bergamo Orio al Serio e Torino Caselle."],
    ["Il personale aeroportuale è certificato?", "Sì, gli addetti alla sicurezza aeroportuale sono formati e certificati da ENAC e Polizia di Stato e operano come incaricati di pubblico servizio."],
    ["Quale norma regola la sicurezza di porti e stazioni?", "I servizi di sicurezza sussidiaria in porti, stazioni e mezzi di trasporto sono disciplinati dal D.M. 154/2009."],
  ],
};

export const PROFILI = ["Privato", "Condominio", "Azienda", "Negozio", "Ente pubblico"];

/* Servizio preselezionato nel modulo preventivo per pagina o scheda di provenienza */
export const SERVICE_NEEDS = {
  "pronto-intervento": "Pronto intervento su allarme",
  antirapina: "Vigilanza antirapina",
  pattugliamento: "Pattugliamento e vigilanza ispettiva",
  piantonamento: "Piantonamento e vigilanza fissa",
  "trasporto-valori": "Custodia o trasporto valori",
  "custodia-valori": "Custodia o trasporto valori",
  "sala-conta": "Sala conta",
  "scorta-valori": "Scorta valori",
  antitaccheggio: "Vigilanza antitaccheggio",
  portierato: "Vigilanza non armata e portierato",
  eventi: "Vigilanza non armata e portierato",
  cinofili: "Unità cinofila",
  aeroportuale: "Sicurezza per obiettivi sensibili",
  "porti-stazioni": "Sicurezza per obiettivi sensibili",
  "centrale-operativa": "Pronto intervento su allarme",
  "obiettivi-sensibili": "Sicurezza per obiettivi sensibili",
};

export const slugNeed = (n) =>
  n.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

/* Accetta sia l'id della pagina/servizio sia lo slug del bisogno */
export const needFromParam = (p) => {
  if (!p) return null;
  if (SERVICE_NEEDS[p]) return SERVICE_NEEDS[p];
  return NEEDS.find((n) => slugNeed(n) === p) || null;
};

export const NEEDS = [
  "Pronto intervento su allarme",
  "Vigilanza antirapina",
  "Pattugliamento e vigilanza ispettiva",
  "Vigilanza antitaccheggio",
  "Piantonamento e vigilanza fissa",
  "Custodia o trasporto valori",
  "Sala conta",
  "Scorta valori",
  "Vigilanza non armata e portierato",
  "Sicurezza per obiettivi sensibili",
  "Unità cinofila",
  "Non so, ho bisogno di una consulenza",
];

/* Dimensioni reali dei file immagine: attributi width/height contro i salti di impaginazione */
const DIMS = {
  "pattuglia-auto.jpg": [2000, 1550],
  "flotta-pattuglie.jpg": [2000, 1438],
  "guardia-aeroporto-cargo.jpg": [2000, 1333],
  "guardia-presidio-orizzontale.jpg": [1717, 1065],
  "furgoni-blindati.jpg": [2000, 1441],
  "magazzino-custodia.jpg": [2000, 1464],
  "caveau.jpg": [2000, 1594],
  "trasporto-valori-guardia.jpg": [2000, 1102],
  "controllo-esplosivi.jpg": [2000, 1296],
  "sicurezza-ferroviaria.jpg": [1000, 500],
  "controllo-merci-aeroporto.jpg": [2000, 1161],
  "aeroporto-tramonto-orizzontale.jpg": [1600, 900],
  "centrale-operativa.jpg": [2000, 1333],
  "sala-operativa-panoramica.jpg": [2000, 1238],
  "sala-operativa-team.jpg": [2000, 1333],
  "sala-operativa-videowall.jpg": [2000, 1637],
  "sala-operativa-pareti-video.jpg": [2000, 1610],
  "sala-operativa-operatore.jpg": [2000, 1462],
  "sala-operativa-monitor.jpg": [2000, 1333],
  "control-room.jpg": [2000, 1481],
  "sede-san-cesareo-drone-1.jpg": [2000, 1238],
  "sede-san-cesareo-drone-2.jpg": [2000, 1399],
  "pattuglia-colosseo.jpg": [2048, 1536],
};
export const dim = (p) => {
  const [w, h] = DIMS[p.split("/").pop()] || [1200, 800];
  return { width: w, height: h, decoding: "async" };
};

export const img = (p) => `${A}/foto/${p}`;
export const logo = (p) => `${A}/logo/${p}`;
export const gruppo = (p) => `${A}/gruppo/${p}`;
export const aurea = (p) => `${A}/aurea/${p}`;
